The input for synchronizing positions.
